const getPaymentMethodCode = require('./getPaymentMethodCode');

module.exports = ({ payments, methodName }) => {
  var methodCode = getPaymentMethodCode(methodName);
  return payments.filter(p => methodName ? p.method === methodCode : true);
};